<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="container-fluid cmps-widget-metric-focus"
    *ngIf="!hasPendingData && data != null"
>
    <div class="row">
        <div
            class="col-12 col-sm-{{ 12 / data.length }} mf-pie"
            *ngFor="let i of data"
        >
            <cmps-widget-pie-bar [data]="i"></cmps-widget-pie-bar>
        </div>
    </div>
</div>
